import Vue from 'vue'
import {
	Autocomplete,
	Empty,
	Drawer,
	Steps,
	Step,
	Icon,
	Table,
	Tabs,
	Dropdown,
	DropdownMenu,
	DropdownItem,
	Tag,
	TableColumn,
	Input,
	Radio,
	RadioGroup,
	RadioButton,
	Checkbox,
	Button,
	TabPane,
	Form,
	Aside,
	FormItem,
	Main,
	Container,
	Menu,
	Submenu,
	MenuItem,
	Divider,
	Card,
	CheckboxGroup,
	Switch,
	Col,
	TimePicker,
	DatePicker,
	Upload,
	Option,
	Select,
	Message,
	Dialog,
	Image,
	Pagination,
	MessageBox,
	Tooltip,
	Loading,
	Collapse,
	CollapseItem,
	Cascader,
	Row,
	OptionGroup,
	InputNumber,
	Carousel,
	CarouselItem,
	Notification
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Empty)
Vue.use(OptionGroup)
Vue.use(Autocomplete)
Vue.use(Row)
Vue.use(Cascader)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Drawer)
Vue.use(Steps).use(Step)
Vue.use(Loading.directive)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Image)
Vue.use(CheckboxGroup)
Vue.use(Icon)
Vue.use(Dialog)
Vue.use(Table)
Vue.use(Tag)
Vue.use(Option)
Vue.use(Select)
Vue.use(Tabs)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Col)
Vue.use(Upload)
Vue.use(Switch)
Vue.use(TabPane)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Aside)
Vue.use(Button)
Vue.use(FormItem)
Vue.use(Container)
Vue.use(Divider)
Vue.use(Main)
Vue.use(Menu)
Vue.use(Input)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(Form)
Vue.use(TableColumn)
Vue.use(Card)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(InputNumber)
Vue.use(Carousel).use(CarouselItem)


Vue.prototype.$message = Message
Vue.prototype.$alert = MessageBox.Alert
Vue.prototype.$loading = Loading.service
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification